const informationItemInputsContainerStyle = {
  container: {
    display: 'flex',
    gap: '100px',
    alignItems: 'center',
  },
};

export default informationItemInputsContainerStyle;
